import { CanvasBlockEditor } from './canvas-block-editor'
import type { CanvasBlockSpec } from './use-canvases'

const BMC_AREA_CLASS: Record<string, string> = {
  key_partners: 'md:[grid-area:partners]',
  key_activities: 'md:[grid-area:activities]',
  key_resources: 'md:[grid-area:resources]',
  value_propositions: 'md:[grid-area:value]',
  customer_relationships: 'md:[grid-area:relationships]',
  channels: 'md:[grid-area:channels]',
  customer_segments: 'md:[grid-area:segments]',
  cost_structure: 'md:[grid-area:costs]',
  revenue_streams: 'md:[grid-area:revenue]',
}

export function BusinessModelCanvas({
  specs,
  blocks,
  onChangeBlock,
}: {
  specs: CanvasBlockSpec[]
  blocks: Record<string, string[]>
  onChangeBlock: (blockId: string, items: string[]) => void
}) {
  return (
    <div className="grid min-h-[36rem] grid-cols-1 gap-px overflow-hidden border border-border bg-border md:grid-cols-5 md:grid-rows-[minmax(10rem,1fr)_minmax(10rem,1fr)_minmax(8rem,auto)] md:[grid-template-areas:'partners_activities_value_relationships_segments'_'partners_resources_value_channels_segments'_'costs_costs_costs_revenue_revenue']">
      {specs.map((spec) => (
        <CanvasBlockEditor
          key={spec.id}
          spec={spec}
          items={blocks[spec.id] ?? []}
          onChange={(items) => onChangeBlock(spec.id, items)}
          className={`h-full border-0 ${BMC_AREA_CLASS[spec.id] ?? ''}`}
        />
      ))}
    </div>
  )
}
